import { createSelector } from "@ngrx/store";
import { IUnidadeState } from "./unidade.reducer";
import { IUnidade } from "src/app/shared/interfaces/unidade/iunidade";

const unidadeStore = (state: any) => state.unidade as IUnidadeState;

export const selectUnidadeLista = createSelector(
    unidadeStore,
    (state) => state.lista
)

export const selectUnitActiveList = createSelector(
    unidadeStore,
    (state) => {
        return state.lista.filter((unidade: IUnidade) => unidade.isActive)
    }
)

export const selectUnitState = createSelector(
    unidadeStore,
    (state) => ({type: state.type, action: state.action})
)

export const selectCurrentUnit = createSelector(
    unidadeStore,
    (state) => state.currentUnit
)

export const selectMainUnit = createSelector(
    unidadeStore,
    (state) => state.lista.filter((res: any) => res.main == true)
)

export const selecPostUnitError = createSelector(
    unidadeStore,
    (state) => state.error
)

